/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Automatic_Fixes_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Fixes" |
*
* @param {Qc_Automatic_Fixes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_automatic_fixes_title = /** @type {((inputs?: Qc_Automatic_Fixes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Automatic_Fixes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corrections automatiques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Korrekturen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correzioni automatiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматические исправления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correcciones automáticas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动修复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित सुधार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correções automáticas")
	return /** @type {LocalizedString} */ ("Automatic Fixes")
});